$(document).ready(function()
{

    $( ".matches-menu a" ).click(function(e)
    {
        e.preventDefault();
        var filterValue = $(this).data("filter-value");
        var filterText = $(this).text();
        $('#matchesDropdown').html(filterText);
        applyDropdownFilters(filterValue, filterText);
    });


    function applyDropdownFilters(filterValue, filterText)
    {
        let active_ids = 0;
        $('#team-name').html(filterText);

        // first hide them all
        $('.matches-group .col').each(function(i, obj)
        {
            if ( $(this).hasClass( "team-divider" ) )
            {
                //ignore
            }
            else
            {
                $(this).fadeOut(300);
            }
        });


        setTimeout(
            function()
            {
                showActiveCards(filterValue);
            }, 300
        );

        function showActiveCards(filterValue)
        {
            $('#team-divider').fadeIn(300);
            // return those inside the current limit
            $('.matches-group .col').each(function(i, obj)
            {
                showItem = 0;

                if(!filterValue || (filterValue && $(this).data('category') == filterValue) )
                {
                    showItem++;
                }
                if(showItem > 0)
                {
                    active_ids++;
                    $(this).fadeIn(300);

                    var month = "#" + $(this).data('month');
                    $(month).fadeIn(300);
                }

            });

            
            
        }

    }

});